"use client";

import { type MapTile } from "@oreme/ui";
import { useAtomValue, useAtom } from "jotai";
import {
  Map as MapLibre,
  LngLatBoundsLike,
  LngLatLike,
  LightSpecification,
} from "maplibre-gl";
import { useMap } from "maplibre-react-components";
import { mapProjectionAtom, mapTileAtom } from "@/store/sites";

function useMapLibre() {
  const map = useMap("map");
  const [tile, setMapTile] = useAtom(mapTileAtom);
  const projection = useAtomValue(mapProjectionAtom);
  const sprite = "https://static.oreme.org/shared/icons/sprite";
  const light: LightSpecification = {
    anchor: "viewport",
    color: "white",
    intensity: 0.4,
  };

  const init = (map: MapLibre): void => {
    if (!map) return;

    if (projection) {
      map.setProjection({ type: projection.id });
    }

    map.setLight(light);
    map.setSprite(sprite);
  };

  const setTile = (tile: MapTile): void => {
    if (map) {
      setMapTile(tile);
    }
  };

  const flyTo = (position: LngLatLike, zoom?: number): void => {
    if (map) map.flyTo({ center: position, zoom: zoom, essential: true });
  };

  const fitBounds = (bounds: LngLatBoundsLike): void | false => {
    if (map && bounds) {
      map.fitBounds(bounds, { padding: 100, duration: 1000 });
    } else {
      return false;
    }
  };

  return {
    map,
    tile,
    projection,
    sprite,
    init,
    setTile,
    flyTo,
    fitBounds,
  };
}

export { useMapLibre };
